import React, { Component } from "react";
import { Link } from "react-router-dom";

//Utilities
import Joi from "joi-browser";

//Components
import Form from "../../components/common/form";
import withMyHook from "../../components/common/withMyHook";
import NavbarGroup from "../../components/navbarGroup";

// Services
import httpService from "./../../services/httpService.js";
import config from "../../config.json";

// Utilities
import { ToastContainer, Zoom, toast } from "react-toastify";

//Other
import { ArrowLeftCircle } from "react-bootstrap-icons";

class RaceUserForm extends Form {
  state = {
    data: {
      firstname: "",
      surname: "",
      cell: "",
      email: "",
      userPassword: "",
    },

    errors: {},
    groupID: "",
    groupName: "",
    myParams: this.props.myParams,
    myNavigate: this.props.myNavigate,
  };

  schema = {
    firstname: Joi.string().label("Firstname"),
    surname: Joi.string().label("Surname"),
    cell: Joi.string()
      .regex(/^[0-9]{10}$/)
      .label("Cell No"),
    email: Joi.string().label("Email Address").email(),
    userPassword: Joi.string().label("Login Password"),
  };

  async componentDidMount() {
    // Get the group id and transfered  race id
    const raceUserID = this.state.myParams.id;

    const groupID = localStorage.getItem("groupID");
    const groupName = localStorage.getItem("groupName");

    // Set the State
    this.setState({ groupID, groupName });

    if (raceUserID === "new") return;
    let { data: raceUser } = await httpService.get(
      config.apiEndpointTeamUserGet + "?id=" + raceUserID
    );

    if (!raceUser) return this.state.myNavigate("/not-found");
    this.setState({ data: this.mapToViewModel(raceUser) });
  }

  //Create or update a user
  doSubmit = async () => {
    const ID = this.state.myParams.id;

    if (ID === "new") {
      // Get the group Id for a new entry
      const groupID = localStorage.getItem("groupID");

      // Add a new entry
      let dataToSend = this.state.data;
      let formData = new FormData();

      // add the group ID to the form data
      formData.append("groupId", groupID);
      Object.keys(dataToSend).forEach((key) => {
        formData.append(key, dataToSend[key]);
      });

      try {
        let addedNew = await httpService.post(
          config.apiEndpointTeamUserAdd,
          formData
        );
      } catch (error) {
        if (error.reponse && error.reponse.status === 404)
          toast.error("Something failed while adding.");
      }
    } else {
      // Update an entry
      let dataToSend = this.state.data;
      let formData = new FormData();

      //add the Id to the data to send to db
      formData.append("id", ID);
      //loop through the data and add to from data
      Object.keys(dataToSend).forEach((key) => {
        formData.append(key, dataToSend[key]);
      });

      try {
        await httpService.post(config.apiEndpointTeamUserUpdate, formData);
      } catch (error) {
        if (error.reponse && error.reponse.status === 404)
          toast.error("Something failed while updating.");
      }
    }
    this.state.myNavigate("/pageRaceUser");
  };

  //Delete a  Group User
  doDelete = async () => {
    const ID = this.state.myParams.id;

    try {
      const deleteReply = await httpService.get(
        config.apiEndpointTeamUsersDelete + "?id=" + ID
      );
      var myObject = JSON.parse(deleteReply);
    } catch (error) {
      if (error.reponse && error.reponse.status === 404)
        toast.error("Something failed while deleting.");
    }

    this.state.myNavigate("/pageRaceUser");
  };

  doClear = () => {
    // clear State data that could have been updated by the changed event if the user started entering the form
    let data = {
      firstname: "",
      surname: "",
      cell: "",
      email: "",
    };

    // update the state
    this.state.data = this.data;

    // clear the form fields
    const blankGroup = {
      firstname: "",
      surname: "",
      cell: "",
      email: "",
    };

    this.setState({ data: this.mapToViewModel(blankGroup) });
    this.state.myParams.id = "new";
    this.state.myNavigate("/pageRaceUser");
  };

  mapToViewModel(raceUser) {
    return {
      firstname: raceUser.name,
      surname: raceUser.surname,
      cell: raceUser.cell,
      email: raceUser.email,
      userPassword: raceUser.userPassword,
    };
  }

  render() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    return (
      <React.Fragment>
        <ToastContainer
          draggable={true}
          transition={Zoom}
          autoClose={2000}
          position="top-center"
        />
        <NavbarGroup />
        <div className="container container-top-70">
          <div className="row">
            <div className="form-container">
              <form onSubmit={this.handleSubmit} id="formID">
                <table className="table table-group">
                  <thead>
                    <tr>
                      <th>
                        <Link to="/pageRaceUser" className="btn p-0">
                          <ArrowLeftCircle color="#002072" size={40} />
                        </Link>
                      </th>
                      <th>
                        <h4>{this.state.groupName}</h4>
                      </th>
                    </tr>
                    <tr align="center">
                      <th colSpan={2}>
                        <h6>Team Member</h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{this.renderInput("firstname", "Name")}</td>
                    </tr>
                    <tr>
                      <td>Surname</td>
                      <td>{this.renderInput("surname", "Surname")}</td>
                    </tr>
                    <tr>
                      <td>Cell Number</td>
                      <td> {this.renderInput("cell", "Cell Number")}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td> {this.renderInput("email", "Email")}</td>
                    </tr>
                    <tr>
                      <td>Password</td>
                      <td>{this.renderPassword("userPassword", "Password")}</td>
                    </tr>

                    <tr align="center">
                      <td colSpan={2}>
                        <span className="button-padding">
                          {this.renderSaveButton("Save")}
                        </span>
                        <span className="button-padding">
                          {this.renderButtonDelete("Delete")}
                        </span>
                        <span className="button-padding">
                          {this.renderButtonClear("Clear")}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withMyHook(RaceUserForm);
